import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0792fef7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "receitas" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "container h-100" }
const _hoisted_5 = { class: "row h-100" }
const _hoisted_6 = { class: "col-md-6 d-flex align-items-end align-items-md-center" }
const _hoisted_7 = { class: "h1" }
const _hoisted_8 = { class: "trabalhe-conosco" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "container h-100" }
const _hoisted_11 = { class: "row h-100 justify-content-end" }
const _hoisted_12 = { class: "col-md-6 d-flex align-items-end align-items-md-center" }
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = { class: "h1" }
const _hoisted_15 = { class: "linha-profissional" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "container h-100" }
const _hoisted_18 = { class: "row h-100" }
const _hoisted_19 = { class: "col-md-6 d-flex align-items-end align-items-md-center" }
const _hoisted_20 = { class: "w-100" }
const _hoisted_21 = { class: "h1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "text-center h1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Highlight = _resolveComponent("Highlight")!
  const _component_HighlightStaticSkeleton = _resolveComponent("HighlightStaticSkeleton")!
  const _component_Separator = _resolveComponent("Separator")!
  const _component_CarouselBrandsHome = _resolveComponent("CarouselBrandsHome")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CarouselHomeHistory = _resolveComponent("CarouselHomeHistory")!
  const _component_Newsletter = _resolveComponent("Newsletter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.allBanners.length)
      ? (_openBlock(), _createBlock(_component_Highlight, {
          key: 0,
          images: _ctx.allBanners
        }, null, 8, ["images"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_HighlightStaticSkeleton)
        ])),
    _createVNode(_component_Separator, { color: "#fff" }),
    _createVNode(_component_CarouselBrandsHome),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.receitasMobile,
        alt: "Vigor receitas mobile",
        class: "img-fluid w-100 d-block d-md-none",
        width: "300",
        height: "200",
        style: { aspectRatio: '3 / 4' },
        fetchpriority: "high"
      }, null, 8, _hoisted_3),
      _createVNode(_component_Separator, { class: "mb-3 d-block d-md-none" }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_7, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('home.receitas.titulo')), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.receitas.descricao')), 1),
              _createVNode(_component_router_link, {
                to: "receitas",
                class: "btn btn-info w-100 w-md-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.receitas.botao')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("img", {
        src: require('@/assets/img/home/trabalhe-conosco-mobile.webp'),
        alt: "Vigor trabalhe conosco mobile",
        class: "img-fluid w-100 d-block d-md-none"
      }, null, 8, _hoisted_9),
      _createVNode(_component_Separator, { class: "mb-3 d-block d-md-none" }),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h2", _hoisted_14, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('home.trabalhe.titulo')), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.trabalhe.descricao')), 1),
              _createVNode(_component_router_link, {
                to: "/trabalhe-conosco",
                class: "btn btn-info w-100 w-md-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.trabalhe.botao')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _createElementVNode("img", {
        src: require('@/assets/img/home/linha-profissional-mobile.webp'),
        alt: "Linha profissional Vigor Alimentos",
        class: "img-fluid w-100 d-block d-md-none"
      }, null, 8, _hoisted_16),
      _createVNode(_component_Separator, {
        class: "mb-3 d-block d-md-none",
        color: "#092055"
      }),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h2", _hoisted_21, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.profissional.titulo')), 1),
                  _hoisted_22,
                  _createTextVNode(_toDisplayString(_ctx.$t('home.profissional.titulo-2')), 1)
                ])
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.profissional.descricao')), 1),
              _createVNode(_component_router_link, {
                to: "/profissional",
                class: "btn btn-info w-100 w-md-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.profissional.botao')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Separator, { class: "d-none d-md-block" }),
    _createElementVNode("section", null, [
      _createElementVNode("h2", _hoisted_23, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('home.nossa-historia')), 1)
      ]),
      _createVNode(_component_CarouselHomeHistory)
    ]),
    _createVNode(_component_Newsletter)
  ], 64))
}